import { useState } from "react";
import apiClient from "../client/ApiGetClient";
import { useMsal } from "@azure/msal-react";

export function useDocumenFile(
  url: string,
  method: string
): {
  downloadFile: (inputValue: string) => Promise<void>;
  isProgress: boolean;
  errorMsg: Error | null;
} {
  const [isProgress, setProgress] = useState(false);
  const [errorMsg, setErrorMsg] = useState<Error | null>(null);
  const { instance, accounts } = useMsal();

  const downloadFile = async (inputValue: string): Promise<void> => {
    try {
      setProgress(true);

      const encodedInputValue = encodeURIComponent(inputValue);
      const requestUrl = `${url}/${encodedInputValue}`;

      console.log("Request URL:", requestUrl);
      console.log("HTTP Method:", method);

      // Make the API request to fetch the file as binary data
      const response = await apiClient.sendRequestDocument(requestUrl, method);

      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }

      const fileBlob = await response.blob();
      const fileURL = URL.createObjectURL(fileBlob);

      // Create a temporary link to download or view the file
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = inputValue; // Set the filename to be the inputValue (or use a custom name)
      link.click();

      // Optionally revoke the object URL after the download to free up memory
      URL.revokeObjectURL(fileURL);
    } catch (error: any) {
      setErrorMsg(error);
      throw error; // Re-throw the error to be caught by the caller
    } finally {
      setProgress(false);
    }
  };

  return { downloadFile, isProgress, errorMsg };
}

export default useDocumenFile;
